
import React, { useState, useEffect, useRef } from 'react';
import styles from '../../styles/Restinfo.module.css';
import * as firebase from 'firebase';
  
const RestInfo = (props) => {

  const userId = props.data
  const { passLW, name } = props
  let gotLW;
  if (passLW) {
    gotLW = passLW[0]
  }
  //const gotLW = passLW[0]

  const [height, setHeight] = useState("")
  const [gender, setGender] = useState("");
  const [date, setDate] = useState("");

  // best way to check for mounted component !!
  const isCurrent = useRef(true);

  useEffect(() => {
      return () => {
      isCurrent.current = false;
      }
  }, [])

  
  const getDataFirebase = (userId) => {
    let data;
    // getting data from location for HEIGHT
    let getData = firebase.database().ref('/users/' + userId + '/height');
    getData.on('value', function(snapshot) {
        console.log(snapshot.val());
        data = snapshot.val();
        if (data !== null) {
            if (isCurrent.current) { setHeight(data.height) }
        }
    })
    let dataGender;
    // getting data from location for GENDER
    let getDataGender = firebase.database().ref('/users/' + userId + '/gender');
    getDataGender.on('value', function(snapshot) {
        console.log(snapshot.val());
        dataGender = snapshot.val();
        if (dataGender !== null) {
            if (isCurrent.current) { setGender(dataGender.gender) }
        }
    })
    let dataBirth;
    // getting data from location for BIRTHDATE
    let getDataBirth = firebase.database().ref('/users/' + userId + '/birth');
    getDataBirth.on('value', function(snapshot) {
        console.log(snapshot.val());
        dataBirth = snapshot.val();
        if (dataBirth !== null) {
            if (isCurrent.current) { setDate(dataBirth.birth) }
        }
    })
  }
  
  useEffect(() => {
    getDataFirebase(userId)  //user.uid);
  }, [userId])
  
  const bmi = gotLW / ((height*height)/10000)
  let bmiStyle = styles.BmispanNormal
  if (bmi < 18.5 || bmi > 24.9) {
    bmiStyle = styles.BmispanNotNormal
  }
  let arrow = <img className={styles.Arrowimg} src={require('../../icons/same.png')} alt="minus sign"/>
  function sum(total, num) {
    return total - num ;
  }
  if (passLW) {
    let whatArrow = passLW.reduce(sum) / passLW.length;
    if (passLW[passLW.length -1] < whatArrow) {
      arrow = <img className={styles.Arrowimg} src={require('../../icons/downarrow.png')} alt="down arrow"/>
    } else if (passLW[passLW.length -1] > whatArrow) {
      arrow = <img className={styles.Arrowimg} src={require('../../icons/uparrow.png')} alt="up arrow"/>
    }
  }

  return (
    <div className={styles.Main}>
      <div className={styles.MainTitle} >
        <p>Osnovni podatki</p>
      </div>
      <div className={styles.MainInfo}>
        <div className={styles.Info}>
          <p>Ime: <span>{name}</span></p>
        </div>
        <div className={styles.Info}>
          <p>Rojstni dan: <span>{date}</span></p>
        </div>
        <div className={styles.Info}>
          <p>Višina: <span>{height}</span> cm</p>
        </div>
        <div className={styles.Info}>
          <p>Teža: <span>{gotLW}</span></p>
          {arrow}
        </div>
        <div className={styles.Info}>
          <p>Spol: <span>{gender}</span></p>
        </div>
        <div className={styles.Info}>
          <p>BMI: <span className={bmiStyle} >{bmi.toFixed(2)}</span></p>
        </div>
      </div>
    </div>
  );
};

export default RestInfo;